module.exports = __webpack_public_path__ + "36e05f49d952c9c04b8318e7a50609e7.png";